/**
 * Tracking status vocabulary, shared by the badge and the scan history.
 */
/**
 * How each tracking status reads, and how loudly.
 *
 * One vocabulary for both shipping services: the API normalises Shippo's and
 * EasyPost's words onto these before they get here, so nothing on screen needs
 * to know which one bought the label.
 */
export const TRACKING_STATUSES = {
  pre_transit: { label: 'Label created', tone: 'bg-slate-100 text-slate-700 border-slate-200' },
  in_transit: { label: 'In transit', tone: 'bg-blue-50 text-blue-700 border-blue-200' },
  out_for_delivery: { label: 'Out for delivery', tone: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  delivered: { label: 'Delivered', tone: 'bg-green-50 text-green-700 border-green-200' },
  available_for_pickup: { label: 'Ready for pickup', tone: 'bg-green-50 text-green-700 border-green-200' },
  return_to_sender: { label: 'Returned to sender', tone: 'bg-amber-50 text-amber-800 border-amber-200' },
  failure: { label: 'Delivery problem', tone: 'bg-red-50 text-red-700 border-red-200' },
  cancelled: { label: 'Cancelled', tone: 'bg-slate-100 text-slate-600 border-slate-200' },
  error: { label: 'Tracking error', tone: 'bg-red-50 text-red-700 border-red-200' },
  unknown: { label: 'No scans yet', tone: 'bg-slate-100 text-slate-600 border-slate-200' },
};

export function describeTrackingStatus(status) {
  return TRACKING_STATUSES[status] ?? { label: status ?? 'Not tracked yet', tone: TRACKING_STATUSES.unknown.tone };
}

